import appConfigSlice from 'src/models/appConfig/slice';
import authSlice from 'src/models/auth/slice';
import AuthModule from 'src/modules/auth/module';
import CopilotModule from 'src/modules/copilot/module';
import copilotSlice from 'src/modules/copilot/slice';
import HeaderModule from 'src/modules/header/module';
import SampleDialog from 'src/modules/sampleDialogModal/module';
import ProgressiveStepper from 'src/modules/stepper/module';
import progressiveStepperSlice from 'src/modules/stepper/slice';

export const moduleList = {
  ...ProgressiveStepper,
  ...HeaderModule,
  ...SampleDialog,
  ...AuthModule,
  ...CopilotModule,
};

export const reducerList = {
  ...progressiveStepperSlice,
  ...authSlice,
  ...appConfigSlice,
  ...copilotSlice,
};
